// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.fixedHeader {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
}

.label {
  padding: 2px 2px;
  margin: 0px;
  font-size: small;
  color: dimgray;
  font-family: Roboto Condensed;
}

.subLabel {
  padding: 2px 2px;
  margin: 0px;
  font-size: x-small;
  color: dimgray;
  font-family: Roboto Condensed;
}

.nombreArticulo {
  font-size: small;
  color: dimgray;
  font-family: Roboto Condensed;
  margin: 0 0 0 0;
}

.nombreCliente {
  font-size: larger;
  color: dimgray;
  font-family: Roboto Condensed;
  margin: 0 0 0 0;
}

.labelPrecio {
  font-size: small;
  color: brown;
  font-family: Roboto Condensed;
  margin: 0 0 0 0;
}

.labelPrecioEspecial {
  font-size: x-small;
  color: brown;
  font-family: Roboto Condensed;
  margin: 0 0 0 0;
}

.btnCarrito {
  padding: 0%;
  font-family: Roboto Condensed;
}

.contadorUnidades {
  align-self: center;
  text-align: center;
}

.iconosCarrito {
  color: #006748;
}

.iconosCarritoDisable {
  color: rgba(0, 103, 72, 0.5019607843);
}

.celdaTablaImporte {
  border: solid 1px #ddd;
}

ion-select {
  font-size: small;
  color: dimgray;
  font-family: Roboto Condensed;
  font-weight: bold;
}

.labelUnidades {
  font-family: Roboto Condensed;
}

.labelUnidadesError {
  color: red;
  font-family: Roboto Condensed;
}

.labelPrecioError {
  color: red;
  font-family: Roboto Condensed;
}

.labelDescuentoError {
  color: red;
  font-family: Roboto Condensed;
}

.smallCondensed {
  font-size: small;
  font-family: Roboto Condensed;
  margin: 0 0 0 0;
}

.labelDescuentoGeneral {
  font-size: small;
  color: dimgray;
  font-family: Roboto Condensed;
  font-weight: bold;
  --padding-top: 0px;
  --padding-end: 0px;
  --padding-bottom: 0px;
  min-height: 0;
}

.labelDescuentoGeneralError {
  font-size: small;
  color: red;
  font-family: Roboto Condensed;
  font-weight: bold;
  --padding-top: 0px;
  --padding-end: 0px;
  --padding-bottom: 0px;
}

.botonRedondo {
  --border-radius: 50%; /* Hace el botón redondo */
  --padding-start: 10px;
  --padding-end: 10px;
  --padding-bottom: 10px;
  --padding-top: 10px;
}

hr {
  margin: 0px;
  height: 1px;
  background-color: rgba(var(--ion-color-primary-rgb), 1);
}

mbsc-datepicker {
  font-size: small;
  color: dimgray;
  font-family: Roboto Condensed;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/components/carrito/carrito.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,gBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;AAEJ;;AACA;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,6BAAA;AAEJ;;AAEA;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;AACJ;;AAGA;EACI,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;AAAJ;;AAGA;EACE,iBAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;AAAF;;AAGA;EACI,gBAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;AAAJ;;AAEA;EACI,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;AACJ;;AAEA;EACI,WAAA;EACA,6BAAA;AACJ;;AAEA;EACI,kBAAA;EACA,kBAAA;AACJ;;AAGA;EACG,cAAA;AAAH;;AAEA;EACI,qCAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,iBAAA;AACJ;;AAEA;EACI,6BAAA;AACJ;;AAEA;EACI,UAAA;EACA,6BAAA;AACJ;;AAEA;EACI,UAAA;EACA,6BAAA;AACJ;;AAEA;EACI,UAAA;EACA,6BAAA;AACJ;;AAEA;EACI,gBAAA;EACA,6BAAA;EACA,eAAA;AACJ;;AAEA;EACI,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;AACJ;;AAEA;EACI,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,oBAAA,EAAA,0BAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;AACJ;;AAEE;EACE,WAAA;EACA,WAAA;EAEA,uDAAA;AAAJ;;AAGE;EACE,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,iBAAA;AAAJ","sourcesContent":[".fixedHeader {\r\n    position: sticky;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 9999;\r\n}\r\n\r\n.label {\r\n    padding: 2px 2px;\r\n    margin: 0px;\r\n    font-size: small;\r\n    color: dimgray;\r\n    font-family: Roboto Condensed;\r\n\r\n}\r\n\r\n.subLabel {\r\n    padding: 2px 2px;\r\n    margin: 0px;\r\n    font-size: x-small;\r\n    color: dimgray;\r\n    font-family: Roboto Condensed;\r\n\r\n}\r\n\r\n.nombreArticulo {\r\n    font-size: small;\r\n    color: dimgray;\r\n    font-family: Roboto Condensed;\r\n    margin: 0 0 0 0;\r\n\r\n}\r\n.nombreCliente {\r\n  font-size: larger;\r\n  color: dimgray;\r\n  font-family: Roboto Condensed;\r\n  margin: 0 0 0 0;\r\n\r\n}\r\n.labelPrecio{\r\n    font-size: small;\r\n    color: brown;\r\n    font-family: Roboto Condensed;\r\n    margin: 0 0 0 0;\r\n}\r\n.labelPrecioEspecial{\r\n    font-size: x-small;\r\n    color: brown;\r\n    font-family: Roboto Condensed;\r\n    margin: 0 0 0 0;\r\n}\r\n\r\n.btnCarrito{\r\n    padding: 0%;\r\n    font-family: Roboto Condensed;\r\n}\r\n\r\n.contadorUnidades{\r\n    align-self: center;\r\n    text-align: center;\r\n    // display: contents;\r\n}\r\n\r\n.iconosCarrito {\r\n   color: #006748;\r\n}\r\n.iconosCarritoDisable {\r\n    color: #00674880;\r\n}\r\n\r\n.celdaTablaImporte{\r\n    border: solid 1px #ddd;\r\n}\r\n\r\nion-select {\r\n    font-size: small;\r\n    color: dimgray;\r\n    font-family: Roboto Condensed;\r\n    font-weight: bold;\r\n}\r\n\r\n.labelUnidades{\r\n    font-family: Roboto Condensed;\r\n}\r\n\r\n.labelUnidadesError{\r\n    color: red;\r\n    font-family: Roboto Condensed;\r\n}\r\n\r\n.labelPrecioError{\r\n    color: red;\r\n    font-family: Roboto Condensed;\r\n}\r\n\r\n.labelDescuentoError{\r\n    color: red;\r\n    font-family: Roboto Condensed;\r\n}\r\n\r\n.smallCondensed{\r\n    font-size: small;\r\n    font-family: Roboto Condensed;\r\n    margin: 0 0 0 0;\r\n}\r\n\r\n.labelDescuentoGeneral {\r\n    font-size: small;\r\n    color: dimgray;\r\n    font-family: Roboto Condensed;\r\n    font-weight: bold;\r\n    --padding-top: 0px;\r\n    --padding-end: 0px;\r\n    --padding-bottom: 0px;\r\n    min-height: 0;\r\n}\r\n\r\n.labelDescuentoGeneralError {\r\n    font-size: small;\r\n    color: red;\r\n    font-family: Roboto Condensed;\r\n    font-weight: bold;\r\n    --padding-top: 0px;\r\n    --padding-end: 0px;\r\n    --padding-bottom: 0px;\r\n}\r\n\r\n.botonRedondo {\r\n    --border-radius: 50%; /* Hace el botón redondo */\r\n    --padding-start: 10px;\r\n    --padding-end: 10px;\r\n    --padding-bottom: 10px;\r\n    --padding-top: 10px;\r\n  }\r\n\r\n  hr {\r\n    margin: 0px;\r\n    height: 1px;\r\n    //border-width: 1px;\r\n    background-color: rgba(var(--ion-color-primary-rgb), 1);\r\n  }\r\n\r\n  mbsc-datepicker {\r\n    font-size: small;\r\n    color: dimgray;\r\n    font-family: Roboto Condensed;\r\n    font-weight: bold;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
